import React from "react";
import { Chip } from "@mui/material";

function CustomChip({ value, color }) {
  return (
    <Chip
      label={value}
      variant="outlined"
      sx={{
        border: "none",
        color: "#000",
        ".dark-theme &": { color: "#fffffff" },
        fontWeight: 700,
        borderWidth: "2px",
        backgroundColor: color,
        borderRadius: "5px",
        width: "80%",
      }}
    />
  );
}
export default CustomChip;
